export default "__VITE_ASSET__D5sFBMwn__"